import React, { useState } from "react";
import LimitOrderForm from "../limit-order-form/LimitOrderForm";
import YourPositions from "../user-positions/UserPositions";

import { TabList, Tab, TabPanel } from "./styles";

const MainScreen = () => {
  const [activeTab, setActiveTab] = useState("yourPositions");

  return (
    <div>
      <TabList>
        <Tab
          onClick={() => setActiveTab("yourPositions")}
          active={activeTab === "yourPositions"}
        >
          Your Positions
        </Tab>
        <Tab
          onClick={() => setActiveTab("addPositions")}
          active={activeTab === "addPositions"}
        >
          Add Positions
        </Tab>
      </TabList>
      <TabPanel>
        {activeTab === "yourPositions" && <YourPositions />}
        {activeTab === "addPositions" && <LimitOrderForm />}
      </TabPanel>
    </div>
  );
};

// Here, you'll need to define or import TabList, Tab, and TabPanel, which could be styled components

export default MainScreen;
